/*
 * This file is generated by vscode-ng-tooling. Don't edit by hand.
 */

import { ARCGAUGE_DECLARATIONS } from './components/arc-guage';
import { BARCODE_DECLARATIONS } from './components/barcode';
import { CHARTS_DECLARATIONS } from './components/charts';
import { CUSTOM_FIELDS_DECLARATIONS } from './components/custom-fields';
import { FROMS_DECLARATIONS } from './components/forms';
import { GRID_DECLARATIONS } from './components/grid';
import { DATA_IMPORT_DECLARATIONS } from './components/import';
import { LAYOUT_DECLARATIONS } from './components/layout';
import { NAVBAR_DECLARATIONS } from './components/layout/navbar';
import { SIDEBAR_DECLARATIONS } from './components/layout/sidebar';
import { POPUP_DECLARATIONS } from './components/popup';
import { SLIDER_DECLARATIONS } from './components/slider';
import { WAREHOUSELOAD_DECLARATIONS } from './components/warehouseload';
import { DIRECTIVES_DECLARATIONS } from './directives';
import { LOADER_DECLARATIONS } from './modules/loader';
import { SPINNER_DECLARATIONS } from './modules/spinner';
import { USERS_DECLARATIONS } from './users';
import { DONUTCHART_DECLARATIONS } from './components/donut-chart';
import { STOCKDEACTIVATECOMPONENT_DECLARATIONS } from './components/deactivate-data';
import { SIGNATURE_DECLARATIONS } from './components/signature';
import { CHARTHEADERCOMPONENT_DECLARATION } from './components/chart-header';
import { VIEWER_DECLERATION } from './components/viewer';
import { ASAP_FIELDS_SELECT_FROM_BOXES } from './components/asap-fields-select-from-boxes';
import { NOTE_DECLARATIONS } from './components/note';
import { ACCOUNT_SITES_SELECTION_DECLARATIONS } from './components/account-sites-selection';

export const declarations: any[] = [
  ARCGAUGE_DECLARATIONS,
  DONUTCHART_DECLARATIONS,
  SIGNATURE_DECLARATIONS,
  BARCODE_DECLARATIONS,
  CHARTS_DECLARATIONS,
  CUSTOM_FIELDS_DECLARATIONS,
  DIRECTIVES_DECLARATIONS,
  FROMS_DECLARATIONS,
  GRID_DECLARATIONS,
  DATA_IMPORT_DECLARATIONS,
  LAYOUT_DECLARATIONS,
  LOADER_DECLARATIONS,
  NAVBAR_DECLARATIONS,
  POPUP_DECLARATIONS,
  SIDEBAR_DECLARATIONS,
  SLIDER_DECLARATIONS,
  SPINNER_DECLARATIONS,
  USERS_DECLARATIONS,
  WAREHOUSELOAD_DECLARATIONS,
  STOCKDEACTIVATECOMPONENT_DECLARATIONS,
  CHARTHEADERCOMPONENT_DECLARATION,
  VIEWER_DECLERATION,
  ASAP_FIELDS_SELECT_FROM_BOXES,
  NOTE_DECLARATIONS,
  ACCOUNT_SITES_SELECTION_DECLARATIONS
];
